import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import { success } from 'redux/ducks/Flash';
import { reset, update } from 'redux/ducks/User';
import { Validator } from 'redux/ducks/helpers';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import validator from 'validator';
import zipcodes from 'zipcodes';
import { COUNTRY_CODES, optionsForEnum, ORGANIZATION_TYPES } from 'helpers/enums';
import { EXPECTED_HOURS_OPTIONS } from 'redux/ducks/Registration';
import { get } from 'lodash';
import genericAdd from 'styles/GenericAdd.svg';
import { FormGroup, Label, Input } from 'reactstrap';
import isEmail from 'validator/lib/isEmail';
import './EditProfileScene.scss';
import { hasIncompleteRecipients, mergeRecipients, splitRecipientsForBackend } from '@helpers/userProfile';

export class EditProfileScene extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: {
        phone: '',
        currentPassword: '',
        password: '',
        passwordConfirmation: '',
        ...props.user,
        financialRecipients: mergeRecipients(props.user.receiptEmails, props.user.financeEmail),
      },
      errors: {},
    };

    this.validator = new Validator({
      firstName: { required: true },
      lastName: { required: true },
      companyName: { required: true },
      organizationWebsite: { website: true },
      addressZip: { required: true, length: 5, ofType: 'number' },
      email: { required: true },
      currentPassword: { requiredAlongside: 'password' },
      password: { minLength: 8 },
      passwordConfirmation: { matches: 'password' },
      phone: { phone: true },
    });

    this.onFileChange = this.onFileChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentWillReceiveProps(newProps) {
    if (newProps.updated) {
      this.props.success('Your Profile Has Been Successfully Updated');
      this.props.history.push('/dashboard');
    }
  }

  componentWillUnmount() {
    this.props.reset();
  }

  componentDidMount() {
    const from = get(this.props, 'location.state.from', '');
    if (!from || from !== 'finances') return;

    setTimeout(() => {
      const el = document.getElementById('finances-email');
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }
    }, 500);
  }

  onFileChange(event) {
    const file = event.currentTarget.files[0];

    const reader = new FileReader();
    reader.addEventListener('load', () => {
      this.setState({
        user: {
          ...this.state.user,
          profilePic: reader.result,
        },
      });
    });

    reader.readAsDataURL(file);
  }

  updateField = (field, value) => {
    this.setState(previousState => ({
      ...previousState,
      user: {
        ...previousState.user,
        [field]: value,
      },
    }));
  };

  onFieldChange = (field, transformer) => event => {
    this.updateField(field, transformer ? transformer(event.currentTarget.value) : event.currentTarget.value);
  };

  onPhoneNumberChange(newNumber) {
    let user = { ...this.state.user };
    user['phone'] = newNumber.length === 1 && newNumber.at(0) !== '1' ? `1${newNumber}` : newNumber;

    this.setState({ user });
  }

  handleAddRecipient = e => {
    e.preventDefault();
    this.setState(previousState => {
      const recipients = [...(previousState.user.financialRecipients || [])];
      recipients.push({ email: '', receiveReceipts: false, receiveExports: false });
      return { user: { ...previousState.user, financialRecipients: recipients } };
    });
  };

  handleRecipientChange = (index, field, value) => {
    this.setState(previousState => {
      const recipients = [...(previousState.user.financialRecipients || [])];
      if (!recipients[index]) return null;
      recipients[index] = { ...recipients[index], [field]: value };
      return { user: { ...previousState.user, financialRecipients: recipients } };
    });
  };

  handleDeleteRecipient = index => {
    this.setState(previousState => {
      const recipients = [...(previousState.user.financialRecipients || [])];
      recipients.splice(index, 1);
      return { user: { ...previousState.user, financialRecipients: recipients } };
    });
  };

  onSubmit(e) {
    e.preventDefault();
    const errors = this.validator.validateAll(this.state.user);

    if (hasIncompleteRecipients(this.state.user.financialRecipients)) {
      this.setState({
        errors: { ...errors, financial: 'Please complete all financial recipient fields.' },
      });
      return;
    }

    if (Object.keys(errors).length === 0) {
      const { financialRecipients, ...restUser } = this.state.user;

      const { receiptEmails, financeEmail } = splitRecipientsForBackend(financialRecipients || []);

      this.props.update({
        ...restUser,
        receiptEmails,
        financeEmail,
      });
    } else {
      this.setState({ errors }, () => {
        const firstErrorElement = document.querySelector('.is-invalid');
        if (firstErrorElement) {
          firstErrorElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          });
          firstErrorElement.focus();
        }
      });
    }
  }

  onZipCodeChange = (ev: SyntheticInputEvent<HTMLInputElement>) => {
    const location = zipcodes.lookup(ev.currentTarget.value);
    this.onFieldChange('addressZip')(ev);
    if (location?.city) {
      this.updateField('city', location.city);
    }
    if (location?.state) {
      this.updateField('state', location.state);
    }
  };

  render() {
    const { jobsListed, cancellationRate, responseRate } = this.state.user;
    const financialRecipients = this.state.user.financialRecipients || [];

    return (
      <div className="container">
        <div className="editProfileScene col-12">
          <h2>edit profile</h2>
          <div className="row">
            <div className="col-md-3">
              <div
                style={{
                  backgroundImage: `url(${this.state.user.profilePic || genericAdd})`,
                }}
                className="profile-pic"
                alt="Profile"
              />
              <section>
                <input
                  onChange={this.onFileChange}
                  type="file"
                  name="profilePic"
                  className="custom-file-input"
                  accept="image/*"
                />
                <label className="custom-file-label" htmlFor="profilePic">
                  EDIT PHOTO
                </label>
              </section>
            </div>
            <div className="col-md-9">
              <table className="profile-stats">
                <tr>
                  <th>
                    Jobs Listed
                    <p>Total jobs listed on Go4.</p>
                  </th>
                  <td>{Number(jobsListed) || 0}</td>
                </tr>
                <tr>
                  <th>
                    Response Rate
                    <p>This rate measures how often your organization responds to applications.</p>
                  </th>
                  <td>{typeof responseRate === 'number' ? `${responseRate.toFixed(2)}%` : '-'}</td>
                </tr>
                <tr>
                  <th>
                    Cancellation Rate
                    <p>This rate measures how often a confirmed job is cancelled.</p>
                  </th>
                  <td>{typeof cancellationRate === 'number' ? `${cancellationRate.toFixed(2)}%` : '-'}</td>
                </tr>
              </table>
            </div>
          </div>
          <form id="profileForm" onSubmit={this.onSubmit}>
            <div className="form-group">
              <label htmlFor="firstName">First Name</label>
              <input
                type="text"
                className={classnames('form-control', {
                  'is-invalid': this.state.errors.firstName || this.props.errors.first_name,
                })}
                name="firstName"
                defaultValue={this.state.user.firstName}
                onChange={this.onFieldChange('firstName')}
              />
              <div className="invalid-feedback">
                {this.state.errors.firstName}
                {this.props.errors.first_name}
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="lastName">Last Name</label>
              <input
                type="text"
                className={classnames('form-control', {
                  'is-invalid': this.state.errors.lastName || this.props.errors.last_name,
                })}
                name="lastName"
                defaultValue={this.state.user.lastName}
                onChange={this.onFieldChange('lastName')}
              />
              <div className="invalid-feedback">
                {this.state.errors.lastName}
                {this.props.errors.last_name}
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="companyName">Organization Name</label>
              <input
                type="text"
                className={classnames('form-control', {
                  'is-invalid': this.state.errors.companyName || this.props.errors.company_name,
                })}
                name="companyName"
                defaultValue={this.state.user.companyName}
                onChange={this.onFieldChange('companyName')}
              />
              <div className="invalid-feedback">
                {this.state.errors.companyName}
                {this.props.errors.company_name}
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="organizationWebsite">Organization Website</label>
              <input
                type="text"
                className={classnames('form-control', {
                  'is-invalid':
                    this.state.errors.organizationWebsite || this.props.errors.organization_website,
                })}
                name="organizationWebsite"
                defaultValue={this.state.user.organizationWebsite}
                onChange={this.onFieldChange('organizationWebsite')}
              />
              <div className="invalid-feedback">
                {this.state.errors.organizationWebsite}
                {this.props.errors.organization_website}
              </div>
            </div>

            <div className="row">
              <div className="col form-group">
                <label htmlFor="phone">Phone Number</label>
                <PhoneInput
                  name="phone"
                  onlyCountries={COUNTRY_CODES}
                  enableTerritories
                  preferredCountries={['us']}
                  enableAreaCodes={false}
                  autoFormat={true}
                  inputStyle={{ width: '100%' }}
                  placeholder="Enter phone number"
                  value={this.state.user.phone || ''}
                  country="us"
                  onChange={this.onPhoneNumberChange.bind(this)}
                />
                <div className="invalid-feedback-displayed">
                  {this.state.errors.phone}
                  {this.props.errors.phone}
                </div>
              </div>
              <div className="col-md-6 form-group">
                <label htmlFor="addressZip">Zip Code</label>
                <input
                  type="text"
                  className={classnames('form-control', {
                    'is-invalid': this.state.errors.addressZip || this.props.errors.address_zip,
                  })}
                  name="addressZip"
                  defaultValue={this.state.user.addressZip}
                  onChange={this.onZipCodeChange}
                />
                <div className="invalid-feedback">
                  {this.state.errors.addressZip}
                  {this.props.errors.address_zip}
                </div>
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="streetAddress">Street Address</label>
              <input
                type="text"
                className={classnames('form-control')}
                name="streetAddress"
                defaultValue={this.state.user.street}
                onChange={this.onFieldChange('street')}
              />
            </div>

            <div className="form-group">
              <label className="required" htmlFor="city">
                City
              </label>
              <input
                type="text"
                name={'city'}
                placeholder="Los Angeles"
                value={this.state.user.city}
                className={classnames('form-control')}
                onChange={this.onFieldChange('city')}
              />
            </div>

            <div className="form-group">
              <label className="required" htmlFor="state">
                State
              </label>
              <select
                name="state"
                className={classnames('form-control', 'custom-select')}
                value={this.state.user.state}
                onChange={this.onFieldChange('state')}
              >
                {this.props.states.map((state, index) => {
                  return (
                    <option key={index} value={state.abbreviation}>
                      {state.abbreviation}
                    </option>
                  );
                })}
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="organization">Organization Type</label>
              <select
                className="form-control custom-select"
                name="organization"
                value={this.state.user.defaultEventSettingId}
                onChange={this.onFieldChange('defaultEventSettingId', parseInt)}
              >
                {optionsForEnum(ORGANIZATION_TYPES)}
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="expected_yearly_staffed_hours">
                How many hours do you staff healthcare providers in a year?
              </label>
              <select
                name="expected_yearly_staffed_hours"
                className="form-control custom-select"
                value={this.state.user.expectedYearlyStaffedHours || ''}
                onChange={this.onFieldChange('expectedYearlyStaffedHours')}
              >
                <option disabled value=""></option>
                {EXPECTED_HOURS_OPTIONS.map((option, index) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>

            <div className="divider" />

            <div className="form-group" id="finances-email">
              <label>
                Financial Reporting
                <div className="financeEmailInfo">
                  By default all financial exports and receipts will be sent to the primary email associated
                  with this account. Optionally, you may add below additional email recipients to be
                  subscribed to one or both of the notification streams.
                </div>
              </label>

              {financialRecipients.length === 0 ? (
                <div className="text-center">
                  <button className="btn btn-primary" onClick={this.handleAddRecipient}>
                    Add Financial Reporting Recipients
                  </button>
                </div>
              ) : (
                <div className="financial-recipients-table">
                  <div className="row header-row">
                    <div className="col-5">Email</div>
                    <div className="col-3">Receive Receipts</div>
                    <div className="col-3">Receive Exports</div>
                    <div className="col-1"></div>
                  </div>

                  {financialRecipients.map((recipient, index) => {
                    const isEmailValid = isEmail(recipient.email);
                    const hasSelection = recipient.receiveReceipts || recipient.receiveExports;

                    const showEmailError = recipient.email.length > 0 && !isEmailValid;
                    const showSelectionError = isEmailValid && !hasSelection;

                    return (
                      <div key={index} className="recipient-row">
                        <div className="row">
                          <div className="col-5">
                            <input
                              type="text"
                              className={classnames('form-control', {
                                'is-invalid': showEmailError,
                              })}
                              placeholder="name@company.com"
                              value={recipient.email}
                              onChange={e => this.handleRecipientChange(index, 'email', e.target.value)}
                            />
                          </div>

                          <div className="col-3">
                            <FormGroup check inline>
                              <Label check>
                                <Input
                                  type="checkbox"
                                  checked={recipient.receiveReceipts}
                                  onChange={e =>
                                    this.handleRecipientChange(index, 'receiveReceipts', e.target.checked)
                                  }
                                />
                              </Label>
                            </FormGroup>
                          </div>

                          <div className="col-3">
                            <FormGroup check inline>
                              <Label check>
                                <Input
                                  type="checkbox"
                                  checked={recipient.receiveExports}
                                  onChange={e =>
                                    this.handleRecipientChange(index, 'receiveExports', e.target.checked)
                                  }
                                />
                              </Label>
                            </FormGroup>
                          </div>

                          <div className="col-1">
                            <button
                              type="button"
                              className="btn btn-link p-0"
                              onClick={() => this.handleDeleteRecipient(index)}
                            >
                              <i className="fa fa-trash"></i>
                            </button>
                          </div>
                        </div>

                        {(showEmailError || showSelectionError) && (
                          <div className="row error-row">
                            <div className="col-12 text-danger small">
                              {showEmailError && <div>Please enter a valid email address.</div>}
                              {showSelectionError && <div>Please select at least one notification type.</div>}
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })}

                  <div className="mt-3">
                    <button
                      type="button"
                      className="btn btn-primary btn-sm"
                      onClick={this.handleAddRecipient}
                      disabled={hasIncompleteRecipients(financialRecipients)}
                    >
                      Add
                    </button>
                  </div>
                </div>
              )}
            </div>

            <div className="divider"></div>

            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                className={classnames('form-control', {
                  'is-invalid': this.state.errors.email || this.props.errors.email,
                })}
                name="email"
                onChange={this.onFieldChange('email')}
                defaultValue={this.state.user.email}
              />
              <div className="invalid-feedback">
                {this.state.errors.email}
                {this.props.errors.email}
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="currentPassword">Password</label>
              <input
                type="password"
                className={classnames('form-control', {
                  'is-invalid': this.state.errors.currentPassword || this.props.errors.current_password,
                })}
                placeholder="If you are updating your password, type old password here"
                name="currentPassword"
                defaultValue={this.state.user.currentPassword}
                onChange={this.onFieldChange('currentPassword')}
                data-lpignore="true"
                autoComplete="new-password"
              />
              <div className="invalid-feedback">
                {this.state.errors.currentPassword && <span>Required when updating to a new password</span>}
                {this.props.errors.current_password && <span>Must match current password</span>}
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="password">New Password</label>
              <input
                type="password"
                className={classnames('form-control', {
                  'is-invalid': this.state.errors.password || this.props.errors.password,
                })}
                placeholder="Password must be 8+ characters"
                name="password"
                defaultValue={this.state.user.password}
                onChange={this.onFieldChange('password')}
                data-lpignore="true"
              />
              <div className="invalid-feedback">
                {this.state.errors.password}
                {this.props.errors.password}
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="passwordConfirmation">Confirm Password</label>
              <input
                type="password"
                className={classnames('form-control', {
                  'is-invalid':
                    this.state.errors.passwordConfirmation || this.props.errors.password_confirmation,
                })}
                name="passwordConfirmation"
                defaultValue={this.state.user.passwordConfirmation}
                onChange={this.onFieldChange('passwordConfirmation')}
                data-lpignore="true"
              />
              <div className="invalid-feedback">
                {this.state.errors.passwordConfirmation}
                {this.props.errors.password_confirmation}
              </div>
            </div>
            <div className="controls">
              <Link className="btn btn-link link-button secondary" to="/dashboard">
                Cancel
              </Link>
              <button type="submit" className="btn btn-danger bold-button">
                Update Profile
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    errors: state.user.errors,
    updated: state.user.updated,
    user: state.session.currentUser,
    states: state.enums.usStates,
    eventSettings: state.enums.eventSettings,
    professions: state.enums.professions,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    reset: () => dispatch(reset()),
    success: message => dispatch(success(message)),
    update: user => dispatch(update(user)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditProfileScene);
